
export const PortfolioMessages = {
    ProcessInitiated: "Process is initiated, please wait",
    RegenerateFailed: "Failed to regenerate portfolio",
    ClearFailed: "Failed to clear portfolio",
    
    NO_DATA_FOUND: "No data found",
    NO_STOCKS_FOUND: "No Stocks Found",
    NO_PENDING_ORDERS: "No pending orders found",
    
  };